﻿
// core js modules
// import { SetUpFontFaceObserver } from './modules/fonts';
import { App } from './app';

// Set up the font face observer to handle font loading
// SetUpFontFaceObserver();

// instance our app
const app = new App();